import { Phone, MessageCircle, FileText } from "lucide-react";

const PHONE = "0643693688";
const WHATSAPP_LINK = "https://wa.me/33643693688?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20une%20enseigne.";

export function FloatingBar({ onScrollToForm }) {
  return (
    <div className="fixed bottom-0 left-0 w-full bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-[#262626] z-50 p-3 md:hidden" data-testid="floating-bar">
      <div className="flex items-center gap-2">
        <a href={`tel:${PHONE}`} onClick={() => { if (window.gtag) window.gtag('event','conversion',{send_to:'AW-9775626347/click_appel'}); }}
          className="flex-1 flex items-center justify-center gap-2 bg-[#1a1a1a] border border-[#333] text-white py-3 rounded-xl font-semibold text-sm"
          data-testid="floating-call-btn">
          <Phone className="w-4 h-4" /> Appeler
        </a>
        <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer"
          onClick={() => { if (window.gtag) window.gtag('event','conversion',{send_to:'AW-9775626347/click_whatsapp'}); }}
          className="flex-[1.4] flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 rounded-xl font-bold text-sm shadow-[0_0_20px_rgba(37,211,102,0.3)]"
          data-testid="floating-whatsapp-btn">
          <MessageCircle className="w-4 h-4" /> WhatsApp
        </a>
        <button onClick={onScrollToForm}
          className="flex-1 flex items-center justify-center gap-2 bg-[#00FF66] text-black py-3 rounded-xl font-bold text-sm"
          data-testid="floating-devis-btn">
          <FileText className="w-4 h-4" /> Devis
        </button>
      </div>
    </div>
  );
}
